import React, { useMemo } from 'react'
import { getHeight, sortDataByField, isInvictus, SoundPlayer, getFullPath, DIR_MEDIA_TYPE, getDateTimeFormat } from 'helpers/utils'
import MirsTable from 'components/general/table/Table'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly'
import DateTime from 'components/presentation/DateTime'
import Competitor from 'components/presentation/Competitor'
import { Stack } from 'react-bootstrap'

const getConfiguration = (breakPoint) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = isMobile ? [{ id: "name", desc: false }] : [{ id: 'name', desc: false }];
  configuration.columns = isMobile ? TableColumnsSM() : TableColumns()
  return configuration;
};

export default function TeamMembers({ data }) {

  const { mirs_competition } = useUrlFriendlyToParameters()
  // const { breakPoint } = useViewport();
  // const config = useMemo(() => getConfiguration(breakPoint), [breakPoint]);
  const columns = useMemo(() => TableColumns(), []);

  const athletesWithIssues = checkAthletes(data);
  let hiddenColumns = athletesWithIssues.length > 0 ? athletesWithIssues : [];

  if (isInvictus(mirs_competition)) hiddenColumns.push('birthDate', 'height')
  if (!isInvictus(mirs_competition)) hiddenColumns.push('SportClass')

  return (
    <>
      {data?.team?.athletes &&
        <>
          <a name="members"><h2 className="wrsBiosDetail__h2" ><Label data="LabelTeamMembers" /></h2></a>
          < MirsTable
            data={sortDataByField(data?.team?.athletes, "order", false)}
            // columns={config.columns}
            columns={columns}
            hiddenColumns={hiddenColumns}
            id={`mirs-table-team-members`}
          />
        </>
      }
    </>
  )
}

function TableColumns() {
  return (
    [
      ColumnBib(),
      ColumnName(),
      ColumnHeight(),
      ColumnBirthDate(),
      ColumnSportClass()
    ]
  )
}

function TableColumnsSM() {
  return (
    [
      ColumnName(),
      // ColumnBirthDate(),
    ]
  )
}


function checkAthletes(data) {
  const uniqueIssues = new Set();

  const { team } = data || {};
  const { athletes } = team || {};

  if (!Array.isArray(athletes)) {
    return Array.from(uniqueIssues);
  }

  for (const { person } of athletes) {
    if (person) {
      const missingHeight = person.height === 0;
      const missingBib = person?.registeredEvents?.some((event) => !event.bib);

      if (missingHeight || missingBib) {
        uniqueIssues.add('height');
        uniqueIssues.add('bib');
        break;
      }
    }
  }

  return Array.from(uniqueIssues);
}



function ColumnBib() {
  return (
    {
      Header: <Label data="HeaderBib" />,
      accessor: 'bib',
      className: "text-center",
      headerClassName: "text-center w-10",
      disableSortBy: true,
      id: 'bib',
      Cell: (props) => {
        const row = props.cell.row.original
        const out = Array.isArray(row?.person?.registeredEvents)
          ? row?.person?.registeredEvents?.find(x => x !== undefined)?.bib
          : row?.person?.registeredEvents?.bib
        return (out)
      }
    }
  )
}

function ColumnName() {
  return (
    {
      Header: <Label data="HeaderName" />,
      accessor: 'name',
      className: "text-start",
      headerClassName: "text-start w-30",
      disableSortBy: true,
      id: 'name',
      Cell: (props) => {
        const person = props.cell.row.original?.person;
        return (
          <Stack direction="horizontal" className="justify-content-between">
            <Competitor {...person} shortName={person?.name} hideNoc={true} hidePicture={false} key={`participant-${person?.code}`} />
            {
              person?.audioFile?.audioType && <>&nbsp;<SoundPlayer audioPath={getFullPath(person.code, DIR_MEDIA_TYPE.AUDIO, person?.audioFile?.audioType)} /> </>
            }
          </Stack>
        );
      }
    }
  )
}

function ColumnHeight() {
  return (
    {
      Header: <Label data="HeaderHeightMFt" />,
      accessor: 'height',
      className: "text-start'",
      headerClassName: "text-start w-20",
      disableSortBy: true,
      id: 'height',
      Cell: (props) => {
        const row = props.cell.row.original
        return (getHeight(row?.person?.height))
      }
    }
  )
}

function ColumnBirthDate() {
  return (
    {
      Header: <Label data="HeaderBirthDate" />,
      accessor: 'birthDate',
      className: "text-start'",
      headerClassName: "text-start w-10",
      disableSortBy: true,
      id: 'birthDate',
      Cell: (props) => {
        const row = props.cell.row.original
        const format = getDateTimeFormat('DayMonthShortYear');
        return (
          <DateTime datetime={row?.person?.birthDate} format={format} />
        )
      }
    }
  )
}

export function ColumnSportClass() {
  return (
    {
      Header: <Label data={'HeaderMedical'} />,
      accessor: 'disciplineClass.classCode',
      id: 'SportClass',
      className: 'text-end',
      headerClassName: 'text-end w-10',
      disableSortBy: true,
      Cell: (props) => {
        let row = props.cell.row.original
        let medicalClass = row?.person?.medicalClass
        return medicalClass && <abbr title={medicalClass?.description}>{medicalClass?.classCode}</abbr>
      }
    }
  )
}